module.exports = __webpack_public_path__ + "static/img/智能工业banner21.5ee84647.png";